import React from 'react';
import { Container, Button, Form } from 'react-bootstrap';
import { TextField, MenuItem, InputLabel, Select, FormControl } from '@mui/material';
import { useNavigate } from "react-router-dom";

const BankDetailsForm = () => {
   const navigate = useNavigate();
  const handleSubmit = () => {
    console.log("Form submitted!");
    navigate("/dashboard");
  };
  return (
    <Container className="mt-5"  >
  <Form>
    <fieldset
      style={{
        padding: "20px",
        display: "block", // You can toggle this based on steps
      }}
    >
      <div
        style={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0px 0px 20px #748292",
          transition: "all 0.5s ease-in-out",
        }}
        
      >
        <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
          Bank Details
        </h6>
        <hr
          style={{
            margin: "5px",
            border: "1px solid #748292",
            width: "100%",
          }}
        />

        {/* Name of Bank */}
        <div className="row mb-3">
          <label className="col-md-3 col-form-label text-start">Name of Bank *</label>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the name of the bank"
              required
            />
          </div>
        </div>

        {/* Address 1 */}
        <div className="row mb-3">
          <label className="col-md-3 col-form-label text-start">Address (1) *</label>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the first address"
              required
            />
          </div>
        </div>

        {/* Address 2 (Optional) */}
        <div className="row mb-3">
          <label className="col-md-3 col-form-label text-start">Address (2) Optional</label>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the second address (optional)"
            />
          </div>
        </div>

        {/* Country */}
        <div className="row mb-3">
          <label className="col-md-3 col-form-label text-start">Country *</label>
          <div className="col-md-9">
            <select
              className="form-control shadow-sm"
              required
            >
              <option value="">Select a country</option>
              <option value="india">India</option>
              <option value="usa">USA</option>
              <option value="uk">UK</option>
              <option value="australia">Australia</option>
            </select>
          </div>
        </div>

        {/* City */}
        <div className="row mb-3">
          <label className="col-md-3 col-form-label text-start">City *</label>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the city"
              required
            />
          </div>
        </div>

        {/* Account Name */}
        <div className="row mb-3">
          <label className="col-md-3 col-form-label text-start">Account Name *</label>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the account name"
              required
            />
          </div>
        </div>

        {/* Account Number */}
        <div className="row mb-3">
          <label className="col-md-3 col-form-label text-start">Account Number *</label>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the account number"
              required
            />
          </div>
        </div>

        {/* IBAN */}
        <div className="row mb-3">
          <label className="col-md-3 col-form-label text-start">IBAN *</label>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the IBAN"
              required
            />
          </div>
        </div>

        {/* SWIFT */}
        <div className="row mb-3">
          <label className="col-md-3 col-form-label text-start">SWIFT *</label>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the SWIFT code"
              required
            />
          </div>
        </div>

        {/* Submit Button */}
        <div className="button" style={{textAlign:"center"}}>
          <button type="submit" className="action-button" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </fieldset>
  </Form>
</Container>

  );
};

export default BankDetailsForm;
